module.exports = __webpack_public_path__ + "img/Frank.736c343d.jpg";